import React from "react";
import { Col, Row } from "react-bootstrap";
import { Form, Input } from "antd";
import AddPartner from "./AddPartner/AddPartner";
import TextInput from "../Common/UITextInput/TextInput";
import "./Style.css";
import PartnerManagementListing from "./PartnerManagementListing/PartnerManagementListing";
import useWindowSize from "../../utils/useWindowSize";
import ChangePassword from "../../containers/Pages/Login/ChangePassword";
import Logout from "../../containers/Pages/Login/Logout";
import { connect } from "react-redux";
import { useState } from "react";
import GlobalLeadSearch from "../GlobalLeadSearch/GlobalLeadSearch";
import GlobalLeadSearchOnboarding from "../GlobalLeadSearch/GlobalLeadSearchOnboarding";

const { Search } = Input;

const PartnerManagement = (props) => {
  const { width } = useWindowSize();
  const [partnerRefresh, setPartnerRefresh] = useState(false);

  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };

  const FormItem = Form.Item;
  return (
    <div className="" style={{ maxWidth: "100%" }}>
      {width < 786 && (
        <Row>
          <Col lg={12} xs={12} md={12} sm={12}>
            {/* <FormItem
              name="PartnerManagementsearch"
              colon={false}
              rules={[
                {
                  required: false,
                  message: "Please Select Partner Management Search",
                },
              ]}
              className="m-0 p-0"
            >
              <TextInput
                type="search"
                placeholder="Search Partner, Lead, Employee"
              />
            </FormItem> */}
          </Col>
        </Row>
      )}

      {width > 786 && (
        <Row>
          <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
            <Col md={8} className="search-bar">
              {/* <FormItem
                name="PartnerManagementsearch"
                colon={false}
                rules={[
                  {
                    required: false,
                    message: "Please Select Partner Management Search",
                  },
                ]}
                className="m-0 p-0"
              >
                <TextInput
                  type="search"
                  placeholder="Search Partner, Lead, Employee"
                />
              </FormItem> */}
            </Col>

            <Col md={4}>
              <div className="login-profie">
                <div className="img-sec">
                  <h2>
                    {adminFirstName(
                      props.userDetail?.firstName ??
                      props.userDetail?.userName?.split(" ")[0]?.trim()
                    )}
                  </h2>
                  <h2>
                    {adminLastName(
                      props.userDetail?.lastName ??
                      props.userDetail?.userName?.split(" ")[1]?.trim()
                    )}
                  </h2>
                </div>

                <div className="content-login">
                  <h4>{props.userDetail?.userName}</h4>
                  <h5>{props.userDetail?.roleName}</h5>
                  <div className="content-login-data">
                    {/* <ChangePassword /> */}
                    <div className="admin-small-space"> </div>
                    <Logout />
                    {/* <h6>Change Password | Logout</h6> */}
                  </div>
                </div>
              </div>
            </Col>
          </Col>
        </Row>
      )}

      <Row>
        <Col lg={12} xs={12} md={12} sm={12}>
          <Col md={6} style={{ display: "flex" }} className="btn-partner">
            <AddPartner
              // partnerAdded={partnerAdded}
              // setPartnerAdded={setPartnerAdded}
              partnerRefresh={partnerRefresh}
              setPartnerRefresh={setPartnerRefresh}
            />

            <GlobalLeadSearchOnboarding
              listingRefresh={partnerRefresh}
              setListingRefresh={setPartnerRefresh}
            />
          </Col>

        </Col>
      </Row>

      <Row className="" style={{ maxWidth: "100%" }}>
        <Col md={12} style={{ maxWidth: "100%", overflow: "hidden" }}>
          <PartnerManagementListing
            // partnerAdded={partnerAdded}
            // setPartnerAdded={setPartnerAdded}
            partnerRefresh={partnerRefresh}
            setPartnerRefresh={setPartnerRefresh}
          />
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userDetail: state.auth?.userData,
  };
};

export default connect(mapStateToProps)(PartnerManagement);
